var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 354,
    viewBox: "0 0 354 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3234_7381)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.25,
    cy: 173.196,
    r: 134.054,
    transform: "rotate(-120 176.25 173.196)",
    stroke: "url(#paint0_linear_3234_7381)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.286,
    cy: 172.296,
    r: 158.333,
    transform: "rotate(90 177.286 172.296)",
    stroke: "url(#paint1_linear_3234_7381)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.662 34.2083C282.137 42.0304 278.611 51.1872 270.788 54.662C262.97 58.1367 253.813 54.6106 250.338 46.7845C246.863 38.9663 250.39 29.8096 258.208 26.3388C266.03 22.864 275.187 26.3862 278.658 34.2083H278.662Z",
    fill: "url(#paint2_radial_3234_7381)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0935 272.238C70.4474 277.537 68.0587 283.74 62.7598 286.094C57.4635 288.447 51.2604 286.059 48.9065 280.757C46.5526 275.461 48.9413 269.258 54.2376 266.907C59.5365 264.553 65.7396 266.939 68.0908 272.238H68.0935Z",
    fill: "url(#paint3_radial_3234_7381)"
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 173.5,
    r: 133.5,
    fill: "url(#paint4_radial_3234_7381)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3234_7381)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215 204H153V212H215V204Z",
    fill: "#F9ABFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.688 179.149H95.6875V194.149H195.688V179.149Z",
    fill: "#BEECFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153 155.877H73V165.877H153V155.877Z",
    fill: "#FDFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M292 176.953H154.429V184.758H292V176.953Z",
    fill: "#54D5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.892 160H198V174.035H234.892V160Z",
    fill: "#C99EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.892 201H140V215.035H176.892V201Z",
    fill: "#C99EFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283.762 148H216V163H283.762V148Z",
    fill: "#C5B7FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.95 144.208C231.064 152.03 217.756 161.187 188.233 164.662C158.725 168.137 124.165 164.611 111.051 156.785C97.936 148.966 111.244 139.81 140.752 136.339C170.275 132.864 204.835 136.386 217.935 144.208H217.95Z",
    fill: "url(#paint5_diamond_3234_7381)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.331 282.832C151.859 288.635 142.19 295.429 120.742 298.007C99.3047 300.585 74.197 297.969 64.6693 292.163C55.1416 286.362 64.81 279.568 86.2474 276.993C107.696 274.415 132.803 277.028 142.32 282.832H142.331Z",
    fill: "url(#paint6_diamond_3234_7381)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.49 297.915C262.178 302.39 252.762 304.91 243 305.001L261.649 309.456C268.41 307.415 274.779 304.321 280.525 300.312L270.49 297.915Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300.641 252.468C300.385 255.071 299.949 257.682 299.324 260.299C298.979 261.743 298.579 263.167 298.137 264.554C297.992 265.02 297.831 265.482 297.679 265.938C296.484 270.336 304.404 272.228 303.611 275.551C303.525 276.124 303.332 276.613 303.063 277.024C302.795 277.435 302.43 277.788 302.003 278.077C295.669 281.12 288.727 282.542 281.627 281.813C280.991 281.839 280.363 281.867 279.747 281.915C276.69 282.178 274.071 282.986 272.959 285.792C272.044 287.77 279.986 291.424 275.707 294.661C275.385 294.906 275.032 295.136 274.678 295.374C274.323 295.611 273.972 295.833 273.612 296.061L283.053 298.316C283.515 297.951 283.976 297.586 284.422 297.218C288.124 294.258 281.437 290.905 282.863 288.607C283.219 288.183 283.6 287.799 284.006 287.455C284.417 287.12 284.847 286.816 285.31 286.553C291.665 284.991 297.678 283.789 303.842 281.528C304.485 281.436 305.135 281.353 305.752 281.263C309.489 280.722 312.535 280.007 311.631 277.025C310.661 273.714 304.923 271.91 304.682 267.967C304.905 267.316 305.113 266.662 305.32 266.007C305.729 264.688 306.091 263.349 306.417 261.985C307.04 259.376 307.493 256.769 307.791 254.168L300.643 252.46L300.641 252.468Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.656 298.221C281.759 298.893 280.843 299.536 279.911 300.166L288.209 302.148C289.138 301.526 290.057 300.875 290.954 300.203L282.656 298.221Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 56H282C285.716 60.4348 289.174 65.113 292.34 70H306C302.852 65.113 299.394 60.4348 295.66 56Z",
    fill: "#54D5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3234_7381",
    x1: 176.25,
    y1: 38.642,
    x2: 176.25,
    y2: 307.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3234_7381",
    x1: 42.42,
    y1: 252.964,
    x2: 336.961,
    y2: 170.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#54D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ABFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3234_7381",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(264.714 40.4798) rotate(-23.9496) scale(15.4945 15.4943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3234_7381",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6448 276.486) rotate(-23.9496) scale(10.4962 10.4961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3234_7381",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.096 247.053) rotate(-145.739) scale(106.485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6CEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_diamond_3234_7381",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.307 150.48) rotate(-6.71213) scale(53.813 16.8378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3385FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#899CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_diamond_3234_7381",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.086 287.485) rotate(-6.85344) scale(39.1064 12.4889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#33DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#4DBAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3234_7381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 354,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3234_7381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 77,
    fill: "white",
    transform: "translate(61 138)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleError);
export default __webpack_public_path__ + "static/media/Circle_error.5d3e5c610c6d54b0cadf4e01b5cef64e.svg";
export { ForwardRef as ReactComponent };